export const formatManualCompletionToast = (result = {}, { name } = {}) => {
  const updated = result.updated ?? 0
  if (updated === 1 && name) {
    return `${name} marked as completed.`
  }
  if (updated === 1) {
    return '1 participant marked as completed.'
  }
  if (updated > 1) {
    return `${updated} participants marked as completed.`
  }
  return 'No participants were marked as completed.'
}

export const formatManualCompletionRevertToast = (result = {}, { name, campaignState } = {}) => {
  const updated = result.updated ?? 0
  const target = campaignState === 'completed' ? 'Overdue' : null
  if (updated === 1 && name && target) {
    return `${name} reverted to ${target}.`
  }
  if (updated === 1 && name) {
    return `${name}'s manual completion was undone.`
  }
  if (updated === 1 && target) {
    return `1 participant reverted to ${target}.`
  }
  if (updated === 1) {
    return '1 manual completion was undone.'
  }
  if (updated > 1 && target) {
    return `${updated} participants reverted to ${target}.`
  }
  if (updated > 1) {
    return `${updated} manual completions were undone.`
  }
  return 'No manual completions were undone.'
}
